export const hasScrollbar = (element) => {
    return element.scrollHeight > element.clientHeight;
};
